/* global fetch, FormData */

import { buildApiUrl } from "./config/api";
import { CLIENT_PROTOCOL_VERSION } from "./clientUpdate/buildVersion";
import { notifyUpgradeRequired } from "./clientUpdate/upgradeRequired";

function isFormData(body: BodyInit | null | undefined): boolean {
  return typeof FormData !== "undefined" && body instanceof FormData;
}

export function withCredentials(init: RequestInit = {}): RequestInit {
  const headers = new Headers(init.headers || {});

  if (!isFormData(init.body) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  headers.set("X-Finster-Client-Protocol", String(CLIENT_PROTOCOL_VERSION));

  return {
    ...init,
    credentials: "include",
    headers,
  };
}

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const response = await fetch(buildApiUrl(path), withCredentials(init));
  if (response.status === 426) await notifyUpgradeRequired(response);
  return response;
}
